import React from 'react';

// project-imports
import { slugify } from '../../utils';
import SEO from '../../common/SEO';
import Layout from '../../common/Layout';
import PostOne from '../../components/post/PostOne';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';

// third-party
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

const AuthorArchive = () => {

    // property initialization
    const { slug } = useParams();

    // Reading store data
    const blogData = useSelector(item => item.blog.blogs);

    // Constant variable
    const data = blogData.map(blog => {
        return {
            ...blog,
            author: blog.author.filter(person => slugify(person) === slug)
        }
    }).filter(blog => blog.author.length > 0);

    const authorName = data[0].author[0];

    return (
        <>
            <SEO title={`Longswitch Academy Blogs by ${authorName}`} url={process.env.PUBLIC_URL + `/author/${slugify(data.author)}`} />
            <Layout searchDisable={true}>
                <BreadcrumbOne
                    title={`Posts by ${authorName}`}
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="Author Posts"
                />
                <div className="edu-elements-area edu-section-gap bg-color-white">
                    <div className="container mb--80">
                        <div className="row g-5">
                            <div className="col-lg-12">
                                <div className="row g-5">
                                    {
                                        data.map((item) => (
                                            <div className="col-lg-4 col-md-6 col-12" key={item.id}>
                                                <PostOne data={item} />
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default AuthorArchive;